import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import useMediaQuery from "@mui/material/useMediaQuery";
import "flag-icons/css/flag-icons.min.css";

const languages = [
  { value: "en", label: "EN", country: "gb" },
  { value: "de", label: "DE", country: "de" },
  { value: "ua", label: "UA", country: "ua" },
  { value: "ru", label: "RU", country: "ru" },
  { value: "pl", label: "PL", country: "pl" },
  { value: "es", label: "ES", country: "es" },
  { value: "it", label: "IT", country: "it" },
];

function LanguageChoice({ language }) {
  return (
    <span className="language-choice">
      <span
        className={`fi fi-${language.country} language-choice__flag`}
        aria-hidden="true"
      />
      <span>{language.label}</span>
    </span>
  );
}

function LangSelect(props) {
  const bottomSelector = useMediaQuery("(max-width:950px)");

  return (
    <div className="selectWrap">
      <Select
        MenuProps={{
          id: "lang-1",
          anchorOrigin: {
            vertical: bottomSelector ? "top" : "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: bottomSelector ? "bottom" : "top",
            horizontal: "left",
          },
          PaperProps: {
            style: {
              marginTop: bottomSelector ? "-8px" : "8px",
            },
          },
        }}
        className="langSelect"
        style={{
          fontWeight: "bold",
          fontSize: "20px",
          position: "fixed",
          width: "118px",
          height: "40px",
          inset: "0px 0px 100% 100%",
          marginLeft: "-138px",
          marginTop: "30px",
          color: "orange",
          border: "none",
          background: "transparent",
        }}
        labelId="lang-select"
        id="lang-select"
        value={localStorage.getItem("lang") || "en"}
        renderValue={(value) => {
          const language =
            languages.find((item) => item.value === value) || languages[0];
          return <LanguageChoice language={language} />;
        }}
        onChange={(event) => {
          localStorage.setItem("lang", event.target.value);
          props.func(event.target.value);
        }}
      >
        {languages.map((language) => (
          <MenuItem
            className="language-menu-item"
            key={language.value}
            value={language.value}
          >
            <LanguageChoice language={language} />
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

export default LangSelect;
